const getters = {
  showActive: (state) => state.gjy.showActive,
  curMenuIndex: (state) => state.gjy.curMenuIndex,
  menuList: (state) => state.gjy.menuList,
  pcMenuList: (state) => state.gjy.pcMenuList,
  isPc: (state) => state.gjy.isPc,
  tel: (state) => state.gjy.tel
};
export default getters;
